import { useEffect } from 'react'
import { useStore } from '@/stores/use-store'
import type { AdminUser } from '@/types/database'

interface AdminOverlayProviderProps {
  children: React.ReactNode
  adminUser: AdminUser | null
}

export function AdminOverlayProvider({ children, adminUser }: AdminOverlayProviderProps) {
  const setAdminUser = useStore((state) => state.setAdminUser)

  // Set admin user in store
  useEffect(() => {
    setAdminUser(adminUser)
  }, [adminUser, setAdminUser])

  return <>{children}</>
}
